import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  OnDestroy,
} from '@angular/core';
import { RequestService } from '../../../../services/request.service';
import Asset from '../../../../model/asset';
import { SnackService } from '../../../../services/snack.service';
import Product from 'src/app/model/product/product';
import ProductAsset from 'src/app/model/product-asset';
import { ProductSizeAsset } from 'src/app/model/product-size-asset';
import { SubscriptionBasedComponent } from 'src/app/subscription-helpers/subscription-based.component';
import { FileUploader } from 'ng2-file-upload';
import { ProjectPlacement } from 'src/app/model/project/projectPlacement';
import { ModalService } from 'src/app/services/modal.service';
import { CollectionHelper } from 'src/app/helpers/collection-helper';
import { MAX_UPLOAD_SIZE } from 'src/globals/globals';
import { v4 as uuidv4 } from 'uuid';
import { NgForage } from 'ngforage';
import AssetHelper from '../../../../helpers/asset-helper';
import { DomSanitizer } from '@angular/platform-browser';
import { ProjectDisplayObservableService } from 'src/app/services/project-display-observable.service';
import { StringHelper } from 'src/app/helpers/string-helper';
import ProductSize from '../../../../model/product/product-size';
import { SignSize } from '../../../../model/product/board/sign-size';
import { cloneDeep } from 'lodash';
import { FileHelper } from '../../../../helpers/file-helper';

@Component({
  selector: 'file-picker',
  templateUrl: './file-picker.component.html',
  styleUrls: ['./file-picker.component.scss'],
  providers: [AssetHelper],
})
export class FilePickerComponent
  extends SubscriptionBasedComponent
  implements OnInit, OnDestroy
{
  @Input()
  public hideUpload = false;
  @Input()
  public hideUploadedImages = false;
  @Input()
  public title: string;
  @Input()
  public subtitle: string;
  @Input()
  public formSection: string;
  @Input()
  public inputProduct: Product;
  @Input()
  public inputProjectPlacement: ProjectPlacement;
  @Input()
  public inputProductSize: ProductSize;
  @Input()
  public client = false;
  @Input()
  public offlineUpload = false;
  @Input()
  public fromOldSystem = false;
  @Input()
  public disabled = false;
  @Input()
  public disabledErrorMessage: string;
  @Input()
  public noLeftSpace = false;
  @Input()
  public uploadButtonLabel = 'Bestand toevoegen';
  @Input()
  public watchProjectPlacementAssetsChanges: boolean = false;
  @Input()
  public emitOfflineAssets: boolean = false;
  @Output()
  public answer = new EventEmitter();
  @Output()
  public assetsAdded = new EventEmitter<Asset[]>();
  @Output()
  public assetDeleted = new EventEmitter();
  productAssets: ProductAsset[] = [];
  productSizeAssets: ProductSizeAsset[] = [];
  isImage = FileHelper.isImage;

  blobUrls: string[];

  public uploader: FileUploader = new FileUploader({
    url: '/api/assets/upload',
  });

  public uploading: boolean = false;
  public init: boolean = false;

  constructor(
    private requestService: RequestService,
    private snackService: SnackService,
    private modalService: ModalService,
    private ngForage: NgForage,
    private sanitizer: DomSanitizer,
    private projectDisplayObservableService: ProjectDisplayObservableService,
    private assertHelper: AssetHelper
  ) {
    super();
  }

  ngOnInit() {
    if (this.inputProduct != null) {
      this.setupForProduct();
      this.setupLocalFilesForProductAssets();
    } else if (this.inputProjectPlacement != null) {
      this.setupForProjectPlacement();
      this.setupLocalFilesForProductAssets();
    } else if (this.inputProductSize != null) {
      this.setupForProductSize();
    }
    //Else warning?

    this.init = true;
  }

  setupLocalFilesForProductSizeAssets() {
    if (CollectionHelper.isPopulated(this.productSizeAssets)) {
      this.productSizeAssets.forEach((pza) => {
        if (pza.asset != null && pza.asset.localFile != null) {
          if (this.blobUrls == null) {
            this.blobUrls = [];
          }
          const url = URL.createObjectURL(pza.asset.localFile);
          pza.asset.localSafeUrl = this.sanitizer.bypassSecurityTrustUrl(url);
          this.blobUrls.push(url);
        }
      });
    }
  }

  private setupLocalFilesForProductAssets(): void {
    if (CollectionHelper.isPopulated(this.productAssets)) {
      this.productAssets.forEach((pa) => {
        if (pa.asset != null && pa.asset.localFile != null) {
          if (this.blobUrls == null) {
            this.blobUrls = [];
          }
          const string = URL.createObjectURL(pa.asset.localFile);
          pa.asset.localSafeUrl = this.sanitizer.bypassSecurityTrustUrl(string);
          this.blobUrls.push(string);
        }
      });
    }
  }

  private setupForProductSize(): void {
    this.productSizeAssets = [];
    if (this.inputProductSize.id != null && this.inputProductSize.id > 0) {
      this.requestService
        .get(`product_size_assets/product_size/${this.inputProductSize.id}`)
        .toPromise()
        .then((res) => {
          this.productSizeAssets = res.body;
          this.setupLocalFilesForProductSizeAssets();
        });
    }
  }

  private setupForProduct(): void {
    this.productAssets = [];
    if (this.inputProduct.productAssets != null) {
      this.productAssets = this.inputProduct.productAssets.filter(
        (pa) => pa.formSection === this.formSection
      );
    }
  }

  private setupForProjectPlacement(): void {
    this.productAssets = [];
    if (this.inputProjectPlacement.projectPlacementAssets != null) {
      this.productAssets =
        this.inputProjectPlacement.projectPlacementAssets.filter(
          (pa) => pa.formSection === this.formSection
        );
    }

    if (this.watchProjectPlacementAssetsChanges) {
      this.addSubscription(
        this.projectDisplayObservableService.getProjectPlacementAssetsChangedSubscribable(),
        (id) => {
          if (this.inputProjectPlacement.id === id) {
            this.recalculateProductAssets();
          }
        }
      );
    }
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();

    if (this.blobUrls != null) {
      this.blobUrls.forEach((url) => {
        URL.revokeObjectURL(url);
      });
    }
  }

  recalculateProductAssets() {
    if (this.inputProduct != null) {
      this.productAssets =
        this.inputProduct.productAssets != null
          ? this.inputProduct.productAssets.filter((pa) => {
              return pa.formSection === this.formSection;
            })
          : [];
    } else if (this.inputProjectPlacement != null) {
      this.productAssets =
        this.inputProjectPlacement.projectPlacementAssets != null
          ? this.inputProjectPlacement.projectPlacementAssets.filter((pa) => {
              return pa.formSection === this.formSection;
            })
          : [];
    }
    //Product size assets not applicable here
  }

  async fileAdded(fileList) {
    this.uploading = true;
    let assets: File[] = Array.from(fileList);

    //Quick validation
    if (
      CollectionHelper.isPopulated(assets) &&
      assets.some((a) => a.size > MAX_UPLOAD_SIZE)
    ) {
      this.snackService.showError(
        'Gelieve enkel bestanden kleiner dan 8 MB te selecteren'
      );
      this.uploading = false;
      return;
    }

    try {
      const savedAssets: Asset[] = [];
      for (let i = 0; i < assets.length; i++) {
        const savedAsset = await this.singleFileAdded(assets[i]);
        savedAssets.push(savedAsset);
        if (this.emitOfflineAssets) {
          savedAsset.base64 = await AssetHelper.extractBase64(assets[i]);
        }
      }
      this.answer.emit(this.productAssets);
      if (this.emitOfflineAssets) {
        this.assetsAdded.emit(savedAssets);
      }

      this.snackService.showSuccess(
        `${
          savedAssets.length > 1 ? 'Bestanden' : 'Bestand'
        } succesvol opgeslagen`
      );
    } catch (e) {
      console.error(e);
      const toShowError =
        e === 'Request overschreed limiet op grootte'
          ? 'Gelieve enkel bestanden kleiner dan 8 MB te selecteren'
          : 'Er is iets mis gegaan bij het opslaan van de bestanden';
      this.snackService.showError(toShowError);
      return;
    } finally {
      this.uploading = false;
    }
  }

  private async singleFileAdded(file: File): Promise<Asset> {
    let savedAsset: Asset = await this.uploadAsset(file);

    if (this.inputProduct != null) {
      const savedProductAsset = await this.uploadProductAsset(savedAsset);
      this.productAssets.push(savedProductAsset);
      this.updateListForProduct(savedProductAsset);
    } else if (this.inputProjectPlacement != null) {
      const savedProductAsset = await this.uploadProductAsset(savedAsset);
      this.productAssets.push(savedProductAsset);
      this.updateListForProjectPlacement(savedProductAsset);
    } else if (this.inputProductSize != null) {
      let productSizeAsset = new ProductSizeAsset();
      productSizeAsset.archived = false;
      productSizeAsset.asset = savedAsset;
      productSizeAsset.productSize = this.inputProductSize;
      productSizeAsset.formSection = this.formSection;

      if (this.inputProductSize.id != null && this.inputProductSize.id > 0) {
        productSizeAsset = await this.uploadProductSizeAsset(productSizeAsset);
      } else {
        if (this.inputProductSize instanceof SignSize) {
          this.inputProductSize.uploadedAssetUuids.push(savedAsset.uuid);
        }
      }
      this.productSizeAssets.push(productSizeAsset);
      //updateListFor... is only required if productSize has a list of assets, come back to this later
    }

    return savedAsset;
  }

  private updateListForProjectPlacement(savedProductAsset: ProductAsset): void {
    if (this.inputProjectPlacement.projectPlacementAssets != null) {
      this.inputProjectPlacement.projectPlacementAssets.push(savedProductAsset);
    } else {
      this.inputProjectPlacement.projectPlacementAssets = [savedProductAsset];
    }

    if (this.watchProjectPlacementAssetsChanges) {
      this.projectDisplayObservableService
        .getProjectPlacementAssetsChangedSubscribable()
        .next(this.inputProjectPlacement.id);
    }
  }

  private updateListForProduct(savedProductAsset: ProductAsset): void {
    if (this.inputProduct.productAssets != null) {
      this.inputProduct.productAssets.push(savedProductAsset);
    } else {
      this.inputProduct.productAssets = [savedProductAsset];
    }
  }

  private async uploadProductSizeAsset(
    productSizeAsset: ProductSizeAsset
  ): Promise<ProductSizeAsset> {
    const savedProductSizeAsset: ProductSizeAsset =
      await this.saveProductSizeAsset(productSizeAsset);
    delete savedProductSizeAsset.asset.base64;

    return savedProductSizeAsset;
  }

  private async uploadProductAsset(savedAsset: Asset): Promise<ProductAsset> {
    const productAsset = new ProductAsset();
    productAsset.asset = savedAsset;

    if (
      this.inputProduct != null &&
      !this.client &&
      !this.fromOldSystem &&
      !this.offlineUpload
    ) {
      productAsset.product = this.inputProduct;
    } else if (
      this.inputProjectPlacement != null &&
      !this.client &&
      !this.fromOldSystem &&
      !this.offlineUpload
    ) {
      productAsset.projectPlacement = this.inputProjectPlacement;
    }
    productAsset.formSection = this.formSection;
    let savedProductAsset =
      this.client || this.fromOldSystem || this.offlineUpload
        ? productAsset
        : await this.saveProductAsset(productAsset);
    delete savedProductAsset.asset.base64;

    return savedProductAsset;
  }

  private async uploadAsset(file: File): Promise<Asset> {
    if (this.offlineUpload) {
      return await this.createOfflineAsset(file);
    } else {
      let base64 = await AssetHelper.extractBase64(file);
      return await this.assertHelper.uploadFile(file, base64);
    }
  }

  private async createOfflineAsset(file: File): Promise<Asset> {
    const uuid = uuidv4();
    await this.ngForage.setItem(AssetHelper.getStorageKeyFor(uuid), file);
    if (this.blobUrls == null) {
      this.blobUrls = [];
    }
    const localUrl = URL.createObjectURL(file);
    this.blobUrls.push(localUrl);
    return {
      name: file.name,
      type: file.type,
      size: file.size,
      base64: null,
      localFileUuid: uuid,
      localFile: file,
      localSafeUrl: this.sanitizer.bypassSecurityTrustUrl(localUrl),
    };
  }

  removeFile(item: ProductAsset, index: number) {
    this.modalService.confirmDialog(
      'Bestand verwijderen',
      'Bent u zeker dat u dit bestand wilt verwijderen?',
      (b) => {
        if (b) {
          if (
            this.offlineUpload &&
            item.asset != null &&
            (item.asset.localFileUuid != null || item.id != null)
          ) {
            this.deleteFromOffline(item, index);
          } else if (!this.offlineUpload) {
            this.deleteFromOnline(item, index);
          }
        }
      }
    );
  }

  removeSizeFile(item: ProductSizeAsset, index: number) {
    this.modalService.confirmDialog(
      'Bestand verwijderen',
      'Bent u zeker dat u dit bestand wilt verwijderen?',
      (b) => {
        if (b) {
          if (item.id != null && item.id > 0) {
            this.deleteSizeFromOnline(item).then(() => {
              this.productAssets.splice(index, 1);
              if (this.inputProductSize instanceof SignSize) {
                this.inputProductSize.uploadedAssetUuids =
                  this.inputProductSize.uploadedAssetUuids.filter(
                    (uuid) => uuid !== item.asset.uuid
                  );
              }
              this.snackService.showSuccess('Bestand succesvol verwijderd');
              this.assetDeleted.emit();
            });
          } else {
            //asset itself should actually be cleaned here,
            //but corrupt data seems to already be made in other uses too, so out of scope
            this.productAssets.splice(index, 1);
          }
        }
      }
    );
  }

  private deleteSizeFromOnline(item: ProductSizeAsset): Promise<any> {
    const url = `product_size_assets/${item.id}`;

    return this.requestService.delete(url).toPromise();
  }

  private deleteFromOnline(item: ProductAsset, index: number) {
    let url: string;
    if (this.client || this.fromOldSystem) {
      url = `assets/${item.asset.uuid}`;
    } else {
      url = `productAssets/${item.id}`;
    }
    this.requestService
      .delete(url)
      .toPromise()
      .then((response) => {
        this.productAssets.splice(index, 1);
        if (this.inputProduct != null) {
          const filterPredicate: (predicateInput: ProductAsset) => boolean =
            this.inputProduct.id != null
              ? this.compareToItemId(item)
              : this.compareToItemReference(item);
          if (this.inputProduct.productAssets != null) {
            this.inputProduct.productAssets =
              this.inputProduct.productAssets.filter(filterPredicate);
          }
        } else {
          // this.inputProjectPlacement != null
          const filterPredicate: (predicateInput: ProductAsset) => boolean =
            this.inputProjectPlacement.id != null
              ? this.compareToItemId(item)
              : this.compareToItemReference(item);
          if (this.inputProjectPlacement.projectPlacementAssets != null) {
            this.inputProjectPlacement.projectPlacementAssets =
              this.inputProjectPlacement.projectPlacementAssets.filter(
                filterPredicate
              );
          }
          if (this.watchProjectPlacementAssetsChanges) {
            this.projectDisplayObservableService
              .getProjectPlacementAssetsChangedSubscribable()
              .next(this.inputProjectPlacement.id);
          }
        }
        this.snackService.showSuccess('Bestand succesvol verwijderd');
        this.assetDeleted.emit();
      });
  }

  private compareToItemId(
    item: ProductAsset
  ): (predicateInput: ProductAsset) => boolean {
    return (pa: ProductAsset) => pa.id !== item.id;
  }

  private compareToItemReference(
    item: ProductAsset
  ): (predicateInput: ProductAsset) => boolean {
    return (pa: ProductAsset) => pa !== item;
  }

  private deleteFromOffline(item: ProductAsset, index: number) {
    this.productAssets.splice(index, 1)[0];
    if (item.asset != null) {
      if (this.inputProduct != null) {
        if (this.inputProduct.productAssets != null) {
          this.inputProduct.productAssets =
            this.inputProduct.productAssets.filter((pa) => {
              return (
                pa.asset == null ||
                pa.asset.localFileUuid !== item.asset.localFileUuid ||
                pa.id !== item.id
              );
            });
        }
      } else {
        // this.inputProjectPlacement != null
        if (this.inputProjectPlacement.projectPlacementAssets != null) {
          this.inputProjectPlacement.projectPlacementAssets =
            this.inputProjectPlacement.projectPlacementAssets.filter((pa) => {
              return (
                pa.asset == null ||
                pa.asset.localFileUuid !== item.asset.localFileUuid ||
                pa.id !== item.id
              );
            });
        }
      } //productSize not applicable here
    }
    if (item.asset.localFileUuid != null) {
      this.ngForage.removeItem(
        AssetHelper.getStorageKeyFor(item.asset.localFileUuid)
      );
    }
    this.snackService.showSuccess('Bestand succesvol verwijderd');
    this.assetDeleted.emit();
  }

  async saveProductAsset(productAsset: ProductAsset) {
    return await this.requestService
      .post(productAsset, 'productAssets')
      .toPromise();
  }

  async saveProductSizeAsset(productSizeAsset: ProductSizeAsset) {
    const copy: ProductSizeAsset = cloneDeep(productSizeAsset);

    //Remove all except id and type from productSize reference to prevent serialization errors
    Object.keys(copy.productSize).forEach((key) => {
      if (key !== 'id' && key !== 'type') {
        copy.productSize[key] = undefined;
      }
    });

    return await this.requestService
      .post(copy, 'product_size_assets')
      .toPromise();
  }

  printDisabledWarningMessage() {
    this.snackService.showWarning(
      StringHelper.isEmpty(this.disabledErrorMessage)
        ? 'Uploaden is uitgeschakeld'
        : this.disabledErrorMessage
    );
  }

  shortenName(name: string) {
    name = name.trim().replace(' ', '');
    let result = name.trim().replace(' ', '');
    let split = name.split('.');
    if (split.length > 1) {
      if (name.length > 8) {
        result =
          split[0].substring(0, 9 - split[split.length - 1].length) +
          '...' +
          split[split.length - 1];
      }
    }
    return result;
  }

  getAssetClass(productAsset: ProductAsset, first: boolean): string {
    if (!productAsset.archived) {
      return first ? 'loadedImg' : 'loadedImg asset-left-space';
    }
    return '';
  }

  getSizeAssetClass(
    productSizeAsset: ProductSizeAsset,
    first: boolean
  ): string {
    if (!productSizeAsset.archived) {
      return first ? 'loadedImg' : 'loadedImg asset-left-space';
    }
    return '';
  }
}
